import { render } from "./editHospital.vue?vue&type=template&id=75a1e553&scoped=true"
import script from "./editHospital.vue?vue&type=script&lang=js"
export * from "./editHospital.vue?vue&type=script&lang=js"

import "./editHospital.vue?vue&type=style&index=0&id=75a1e553&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-75a1e553"

export default script